import WidgetConfigEditor from './WidgetConfigEditor';

export default WidgetConfigEditor;
